/**
 * Le socle commun des écrans d'arrêt de travail.
 *
 * Extrait d'`ArretsTravail.tsx` pour que `DetailArret` puisse s'en servir sans
 * créer un cycle d'imports : le détail est utilisé PAR les écrans de liste, il
 * ne peut donc pas importer d'eux.
 */

// Les types d'arrêt ne sont plus une constante : ils se lisent du référentiel
// (hook `useTypesArret`). Douze des seize types de la catégorie Santé étaient
// inatteignables, ce qui vidait de son sens un référentiel administrable.

/**
 * Écrit une DATE PURE (`AAAA-MM-JJ`) à la française.
 *
 * Elle n'accepte QUE une date pure — une colonne `text` du schéma. Lui passer
 * un HORODATAGE la fait mentir d'un jour : les instants sont en UTC, Paris est
 * à +1 ou +2, donc tout ce qui arrive entre minuit et deux heures du matin
 * s'affiche la veille. Le défaut était réel sur `annule_le` (`DetailArret`), et
 * deux balayages successifs l'ont manqué parce que le découpage est le même à
 * l'œil dans les deux cas.
 *
 * Pour un instant : `dateFr(jourAParis(new Date(x)))`, où `jourAParis` vient de
 * `server/lib/dates` — le seul endroit où vit l'arithmétique de dates.
 */
export const dateFr = (iso: string) => iso.slice(0, 10).split('-').reverse().join('/');
